import Vue from "vue";
import AuthPlugin from "@/api/Auth/AuthPlugin";
Vue.use(AuthPlugin, {
  authority: process.env.VUE_APP_SINGLESIGNON,
  client_id: process.env.VUE_APP_CLIENTID,
  response_type: "id_token token",
  scope: "openid profile gafunctions roles"
});
